import { getPostLoginRedirectUrl } from "utils/environment";
import {
  POST_LOGIN_LANDING_PATH,
  consumeStashedPostLoginRedirectUrl,
  sanitizePostLoginRedirectUrl,
} from "utils/authReturnUrl";

export function isLocalhostHost() {
  const host = window.location.hostname;
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]" ||
    /\.local$/.test(host)
  );
}

export function isDevOrLocalhostAuth() {
  const isLocal = isLocalhostHost();
  const isDev = (process.env.REACT_APP_API_URL || "").includes("dev");
  return isLocal || isDev;
}

export function getSubdomainFromAppId(appId) {
  switch (Number(appId)) {
    case 1:
      return "tax";
    case 2:
      return "epr";
    case 3:
      return "invoice";
    case 4:
      return "tax-agent";
    case 5:
      return "omp";
    case 6:
      return "authorize";
    default:
      return "tax";
  }
}

export function buildLoginPath({ search = "", email } = {}) {
  const params = new URLSearchParams(search || "");
  if (email) {
    params.set("email", email);
  }
  const query = params.toString();
  return query ? `/login?${query}` : "/login";
}

export function buildForgotPath(search = "") {
  return search ? `/forgot${search}` : "/forgot";
}

/** Mark a post-login hop so the target subdomain can drop a stale force_logout flag. */
export function withFromLoginFlag(url) {
  if (!url || typeof url !== "string") return url;
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set("fromLogin", "1");
    return parsed.toString();
  } catch {
    return url;
  }
}

/** Post-login redirect (credentials, 2FA, Google/Xero). */
export function handlePostLoginRedirect(res, navigate) {
  const params = new URLSearchParams(window.location.search);
  const fromQuery = sanitizePostLoginRedirectUrl(params.get("redirectUrl"));
  const fromStash = consumeStashedPostLoginRedirectUrl();
  const redirectUrl = fromQuery || fromStash;
  const subdomain = getSubdomainFromAppId(res?.app_id);

  if (redirectUrl) {
    window.location.href = withFromLoginFlag(redirectUrl);
    return;
  }

  if (!isLocalhostHost()) {
    const postLoginUrl = getPostLoginRedirectUrl(subdomain);
    const cookieBase = String(process.env.REACT_APP_COOKIES || "").replace(
      /^\./,
      ""
    );
    const fallbackHost = cookieBase
      ? `${subdomain}.${cookieBase}`
      : subdomain;
    const target =
      postLoginUrl ||
      `https://${fallbackHost}${POST_LOGIN_LANDING_PATH}`;
    window.location.href = withFromLoginFlag(target);
    return;
  }

  window.location.assign("/home");
}
